import LoadingIcon from '@components/sds/icons/loading';
import useInlineStyles from '@components/sds/useInlineStyles';
import inlineStyles from './global-spinner.module.scss?inline';

export interface GlobalSpinnerProps {
  isVisible?: boolean;
  size?: 'small' | 'medium';
}

export const GlobalSpinner = ({
  isVisible = false,
  size,
}: GlobalSpinnerProps) => {
  const clsx = useInlineStyles(inlineStyles);

  if (!isVisible) {
    return null;
  }

  const className = clsx({
    spinner: true,
    visible: isVisible,
    small: size === 'small',
  });

  const backDrop = clsx({ backdrop: true });

  return (
    <div className={className} data-testid="loader">
      <div className={backDrop} />
      <LoadingIcon />
    </div>
  );
};
